<script setup lang="ts">import { toRef as _toRef } from 'vue';

import { onClickOutside } from '@vueuse/core'
import FlyOutCaret from './FlyOutCaret.vue'
import { setupFlyOut } from './composables'

type VariantType = 'menu' | 'list'

withDefaults(defineProps<{
  id: string
  header?: string
  variant?: VariantType
}>(), { variant: 'menu', })

const emit = defineEmits<{ openChange: [open: boolean] }>()

const __$temp_1 = (setupFlyOut()),
  open = _toRef(__$temp_1, 'open'),
  locked = _toRef(__$temp_1, 'locked'),
  setOpen = _toRef(__$temp_1, 'setOpen');

const flyout = useTemplateRef<HTMLElement>('flyout')

watch(() => open.value, () => emit('openChange', open.value as boolean))

onClickOutside(flyout, () => {
  if (!locked.value) setOpen.value(false)
})

function toggleOpen () {
  if (!locked.value) setOpen.value(!open.value)
}

function closeOnEsc () {
  if (!locked.value) setOpen.value(false)
}
</script>

<template>
  <div>
    <div
      ref="flyout"
      class="relative text-v2-tertiary"
      @keydown.esc="closeOnEsc"
      @click="toggleOpen"
    >
      <slot name="trigger"/>

      <dialog
        :id="id"
        :open="open"
        class="relative bg-transparent w-full"
      >
        <div v-show="open">
          <div
            class="absolute right-0 pt-3 z-menu"
          >
            <V2Card
              class="border-none shadow-none"
              style="box-shadow: 0 2.52px 22.52px 9px #0000000f;"
              :class="variant"
            >
              <div v-if="header || $slots.header" class="w-full flex justify-between items-center">
                <slot name="header">
                  <div class="text-lg font-semibold">
                    {{ header }}
                  </div>
                </slot>
              </div>

              <slot name="content"/>
            </V2Card>
          </div>
          <!-- caret -->
          <FlyOutCaret/>
        </div>
      </dialog>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.menu {
  padding: 0 !important;
}

.list {
  padding: 24px !important;
}
</style>
